import { useNavigate } from "react-router-dom";
interface VerifierItem {
  id: string;
  label: string;
  ageRequirement: string;
}

const VerifierItems = () => {
  const navigate = useNavigate();

  const verifierItems: VerifierItem[] = [
    {
      id: "signup",
      label: "본인인증 정보",
      ageRequirement: "signup",
    },
    {
      id: "adult",
      label: "성인인증",
      ageRequirement: "adult",
    },
    {
      id: "minor",
      label: "청소년인증",
      ageRequirement: "minor",
    },
  ];

  const navigateToExplanation = (param: string) => {
    navigate(`/explanation?type=${param}`);
  };

  return (
    <div className="min-h-screen flex flex-col items-center w-full h-full px-6 sm:px-[56px]">
      <div className="mt-8 flex justify-center w-full">
        <img src={"/images/cplabs_logo.webp"} width={95} height={24} />
      </div>
      {/* 상단 타이틀 */}
      <div className="flex flex-col mt-[108px] justify-center items-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">ZKP Sample SP</h1>
      </div>
      <div className="mt-12 text-2xl text-center hidden sm:block">
        <span>ZKP기반 휴대폰 인증서를 이용한 인증 셈플 서비스 입니다.</span>
      </div>
      <div className="text-lg text-gray-600 mt-10 mb-8">
        인증 유형을 선택하세요
      </div>
      <div className="relative">
        {verifierItems.map((item) => (
          <div className="flex items-center justify-center w-screen py-[10px] px-6">
            <button
              className={`w-full sm:max-w-[280px] h-[52px] p-4 rounded-[999px] bg-[#416ab1] text-white`}
              key={item.id}
              onClick={() => navigateToExplanation(item.ageRequirement)}
            >
              <span className="font-medium text-lg">{item.label}</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VerifierItems;
